import DiplomaWorkFilter from "./DiplomaWorkFilter";

export default DiplomaWorkFilter;